module.exports = "<div\n  layout=\"column\" layout-align=\"space-around\"\n  style=\"text-align: center;\"\n  >\n  <md-icon\n    style=\"font-size: 96px; width: 96px; height: 96px; color: #E0E0E0;\"\n    class=\"fa {{icon}}\"\n    >\n  </md-icon>\n\n  <p style=\"color: #999; font-size: 24px\" ng-transclude></p>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./empty-state/tpl.html
// module id = 1125
// module chunks = 0